import axios from 'axios';
import store from 'store';
import routes from '@/router';
import { Message } from 'element-ui';
import commonConfig from './commonConfig.json';

export const get = (cmd, params, reject) => {
  const newParams = { ...params };
  if (store.get('token')) {
    newParams.token = store.get('token');
  }
  newParams.appId = store.get('appId') || commonConfig.APP_ID;
  return axios.get(cmd, {
    params: newParams
  }).then((res) => {
    if (res.data.code === '20004' || res.data.code === '20001') {
      routes.app.$router.push('/login');
      Message.error('您的账号已在其他地方登录');
      return false;
    }
    if (res.data.code) {
      if (reject) {
        reject(res.data);
      } else {
        Message.error(res.data.message);
      }
      return false;
    }
    return res.data.data;
  });
};
export const post = (cmd, params, reject) => {
  const newParams = { ...params };
  if (store.get('token')) {
    newParams.token = store.get('token');
  }
  newParams.appId = store.get('appId') || commonConfig.APP_ID;
  return axios.post(cmd, newParams).then((res) => {
    if (res.data.code === '20004' || res.data.code === '20001') {
      routes.app.$router.push('/login');
      Message.error('您的账号已在其他地方登录');
      return false;
    }
    if (res.data.code) {
      if (reject) {
        reject(res.data);
      } else {
        Message.error(res.data.message);
      }
      return false;
    }
    return res.data.data;
  });
};
